/* eslint-disable no-param-reassign */

import { warn } from '../helpers/common';

// LineItem l = new LineItem();
// l.isValidLineItemBudget(budget, lineItem, isMni)

export function addValidations(obj) {
  // add instance validations for each field
  if (!obj.constructor.validations) {
    return;
  }
  const validations = {};
  Object.keys(obj.constructor.validations).forEach((k) => {
    const vfn = obj.constructor.validations[k];
    function isFieldValid() {
      return vfn(this[k], this);
    }
    validations[k] = isFieldValid.bind(obj);
  });
  obj.validations = validations;

  // add method which tests validity of all fields for which we have validation methods
  function isObjValid() {
    let valid = true;
    Object.keys(this.validations).forEach((k) => {
      if (this.validations[k]()) {
        warn('invalid field: ', k, this[k]);
        valid = false;
      }
    });
    return valid;
  }
  obj.isValid = isObjValid.bind(obj);
}
